import { ERROR_CODE, FIM_DOMAIN, type FimDomain, UniversalError } from "@packages/core";
import { IconBaseProps } from "react-icons";
import { LuBrain, LuFootprints, LuHand, LuHeart, LuSpeech, LuToilet } from "react-icons/lu";
import { Merge } from "type-fest";

export type FimDomainIconProperties = Merge<IconBaseProps, { value: FimDomain }>;
export function FimDomainIcon({ value, ...properties }: FimDomainIconProperties) {
  switch (value) {
    case FIM_DOMAIN.COMMUNICATION:
      return <LuSpeech {...properties} />;
    case FIM_DOMAIN.LOCOMOTION:
      return <LuFootprints {...properties} />;
    case FIM_DOMAIN.SELF_CARE:
      return <LuHeart {...properties} />;
    case FIM_DOMAIN.SOCIAL_COGNITION:
      return <LuBrain {...properties} />;
    case FIM_DOMAIN.SPHINCTER_CONTROL:
      return <LuToilet {...properties} />;
    case FIM_DOMAIN.TRANSFER:
      return <LuHand {...properties} />;
    default:
      throw new UniversalError(
        ERROR_CODE.UNIMPLEMENTED,
        "FIMドメイン" + (value satisfies never) + "のアイコンが実装されていません。",
      );
  }
}
